import {MovimentacaoProcesso} from "../../juridico/models/movimentacao-processo";
import {TarefaDetalhes} from "../../juridico/models/tarefa-detalhes";

export class Dashboard {
  totalProcessos = 0;
  totalProcessosMovimentadosHoje = 0;
  totalAtendimentosSemana = 0;
  totalAtendimentosHoje = 0;
  totalTarefasCadastradas = 0;
  totalTarefasAtendidasHoje = 0;
  totalTarefasEmAtendimento = 0;
  totalCasos = 0;
  totalDocumentos = 0;
  totalTarefas = 0;
  totalAtendimentos = 0;
  totalDefensores = 0;
  totalProcessosMovimentados = 0;
  tarefasHoje: TarefaDetalhes[] = [];
  movimentacoes: MovimentacaoProcesso[] = [];
}
